import { createReducer } from '../../../utils/';
import { combineReducers } from 'redux';
import constant from './constant';

const IndexListhandlers = {
    [constant.INDEXLIST](state, action) {
        return action.payload;
    },
};

const IndexAdListhandlers = {
    [constant.INDEXADLIST](state, action) {
        return action.payload;
    },
}
const StandarLineListHandlers = {
    [constant.STANDARLINELIST](state, action) {
        return action.payload;
    },
}
const stateHandlers = {
    [constant.ListLoading](state, action) {
        return { ...state, loading: action.payload,adloading:action.payload };
    },
    [constant.ListAdLoading](state, action) {
        return { ...state, adloading:action.payload,};
    },
    [constant.STANDARLINELISTAdLoading](state, action) {
        return { ...state, standarLineloading:action.payload,};
    },
};


export const ListStatus = createReducer({ loading: false ,adloading: false,standarLineloading:false}, stateHandlers); // 列表状态
export const IndexList = createReducer([], IndexListhandlers); // 列表
export const IndexAdList = createReducer({}, IndexAdListhandlers); // 列表
export const StandarLineList = createReducer({}, StandarLineListHandlers); // 列表
export const newExportData = combineReducers({
    IndexList,
    ListStatus,
    IndexAdList,
    StandarLineList,
});



// WEBPACK FOOTER //
// ./pages/StatisticalAnalysis/newExportData/reducers.js